<mat-menu #menuMain="matMenu"
	[hasBackdrop]="false"
	id="menu-main-nav-lnk-dropdown-toggle-{{dropdownMenu.id}}"
	class="vtr-material-menu-dropdown mt-0 overflow-wrap-normal max-width-none min-height-0 menu-dropdown-container"
	attr.aria-labelledby="menu-main-nav-lnk-dropdown-toggle-{{dropdownMenu.id}}"
	xPosition="before">
	<section *ngIf="!hasSecondaryMenu && !singleColumnSecondaryMenu && dropdownMenu.id!=='user'">
		<ng-container *ngFor="let subitem of dropdownMenu.subitems; let i=index">
			<button mat-menu-item
				*ngIf="subitem && subitem.hide===false&& subitem.externallink"
				id="menu-main-nav-lnk-dropdown-menu-external-{{parentId}}-{{i}}"
				class="mt-0 py-2 border-radius-0 outline-none h-auto dropdown-menu-item"
				attr.aria-label="{{subitem.label | translate }}"
				routerLinkActive="active"
				[routerLinkActiveOptions]="subitem.routerLinkActiveOptions"
				target="_blank"
				rel="noopener"
				href="javascript:void(0)"
				(click)="openExternalLink(subitem.path)">
				<span class="d-inline-block overflow-hidden w-auto" [innerHTML]="subitem.label | translate"></span>
			</button>
			<button mat-menu-item
				*ngIf="subitem && subitem.hide===false && !subitem.externallink && !subitem.singleLayerRouting"
				id="menu-main-nav-lnk-dropdown-menu-{{parentId}}-{{i}}"
				class="mt-0 py-2 border-radius-0 outline-none h-auto dropdown-menu-item"
				attr.aria-label="{{subitem.label| translate}}"
				routerLinkActive="active"
				[routerLinkActiveOptions]="subitem.routerLinkActiveOptions"
				routerLink="/{{parentPath}}/{{subitem.path}}"
				href="javascript:void(0)"
				role="menuitem"
				(keydown.enter)="menuItemKeyDown(parentPath, subitem.path)">
				<span class="d-inline-block overflow-hidden w-auto" [innerHTML]="subitem.label | translate"></span>
			</button>
			<button mat-menu-item
				*ngIf="subitem && subitem.hide===false && !subitem.externallink && subitem.singleLayerRouting"
				id="menu-main-nav-lnk-dropdown-menu-{{parentId}}-{{i}}"
				class="mt-0 py-2 border-radius-0 outline-none h-auto dropdown-menu-item"
				attr.aria-label="{{subitem.label| translate}}"
				routerLinkActive="active"
				[routerLinkActiveOptions]="subitem.routerLinkActiveOptions"
				routerLink="/{{subitem.path}}"
				href="javascript:void(0)"
				role="menuitem"
				(keydown.enter)="menuItemKeyDown(subitem.path)">
				<span class="d-inline-block overflow-hidden w-auto" [innerHTML]="subitem.label | translate"></span>
			</button>
		</ng-container>
	</section>
	<section *ngIf="hasSecondaryMenu && !singleColumnSecondaryMenu && dropdownMenu.id!=='user'" class="d-flex p-3 secondary-menu-container">
		<section *ngFor="let subitem of dropdownMenu.subitems; let i=index; trackBy:identify"
			class="d-inline-block column-container">
			<button mat-menu-item
				*ngIf="subitem && subitem.hide===false&& subitem.externallink"
				id="menu-main-nav-lnk-dropdown-menu-external-{{parentId}}-{{i}}"
				class="d-inline-block mt-0 py-2 text-uppercase border-radius-0 outline-none h-auto dropdown-menu-item font-weight-bold"
				disabled
				attr.aria-label="{{subitem.label | translate }}"
				target="_blank"
				rel="noopener"
				href="javascript:void(0)">
				<span class="d-inline-block overflow-hidden w-auto" [innerHTML]="subitem.label | translate"></span>
			</button>
			<button mat-menu-item
				*ngIf="subitem && subitem.hide===false&& !subitem.externallink"
				id="menu-main-nav-lnk-dropdown-menu-{{parentId}}-{{i}}"
				class="d-inline-block mt-0 py-2 text-uppercase border-radius-0 outline-none h-auto dropdown-menu-item font-weight-bold"
				disabled
				attr.aria-label="{{subitem.label| translate}}"
				target="_blank"
				href="javascript:void(0)"
				role="menuitem">
				<span class="d-inline-block overflow-hidden w-auto" [innerHTML]="subitem.label | translate"></span>
			</button>
			<section *ngIf="subitem && subitem.hide===false">
				<ng-container *ngFor="let secondarySubitem of subitem.subitems; let ii=index; trackBy:identify">
					<button mat-menu-item
						*ngIf="secondarySubitem && !secondarySubitem.outletLink && secondarySubitem.hide===false && !secondarySubitem.externallink && !secondarySubitem.singleLayerRouting"
						id="menu-main-nav-lnk-dropdown-menu-{{parentId}}-{{subitem.id}}-{{ii}}"
						class="d-inline-block mt-0 py-2 border-radius-0 outline-none h-auto dropdown-menu-item"
						attr.aria-label="{{secondarySubitem.label| translate}}"
						routerLinkActive="active"
						[routerLinkActiveOptions]="secondarySubitem.routerLinkActiveOptions"
						[routerLink]="secondarySubitem.path"
						(click)="OnClick(secondarySubitem)"
						href="javascript:void(0)"
						role="menuitem"
						(keydown.enter)="OnClick(secondarySubitem)">
						<span class="d-inline-block overflow-hidden w-auto" [innerHTML]="secondarySubitem.label | translate"></span>
					</button>
					<button mat-menu-item
						*ngIf="secondarySubitem && secondarySubitem.outletLink && secondarySubitem.hide===false && !secondarySubitem.externallink && !secondarySubitem.singleLayerRouting"
						id="menu-main-nav-lnk-dropdown-menu-{{parentId}}-{{subitem.id}}-{{ii}}"
						class="d-inline-block mt-0 py-2 border-radius-0 outline-none h-auto dropdown-menu-item"
						attr.aria-label="{{secondarySubitem.label| translate}}"
						routerLinkActive="active"
						[routerLinkActiveOptions]="secondarySubitem.routerLinkActiveOptions"
						[routerLink]="secondarySubitem.outletLink"
						href="javascript:void(0)"
						role="menuitem"
						(keydown.enter)="OnClick(secondarySubitem)">
						<span class="d-inline-block overflow-hidden w-auto" [innerHTML]="secondarySubitem.label | translate"></span>
					</button>
					<button mat-menu-item
						*ngIf="secondarySubitem && secondarySubitem.hide===false && !secondarySubitem.externallink && secondarySubitem.singleLayerRouting"
						id="menu-main-nav-lnk-dropdown-menu-{{parentId}}-{{subitem.id}}-{{ii}}"
						class="d-inline-block mt-0 py-2 border-radius-0 outline-none h-auto dropdown-menu-item"
						attr.aria-label="{{secondarySubitem.label| translate}}"
						routerLinkActive="active"
						[routerLinkActiveOptions]="secondarySubitem.routerLinkActiveOptions"
						routerLink="/{{secondarySubitem.path}}"
						href="javascript:void(0)"
						role="menuitem"
						(keydown.enter)="menuItemKeyDown(secondarySubitem.path)">
						<span class="d-inline-block overflow-hidden w-auto" [innerHTML]="secondarySubitem.label | translate"></span>
					</button>
				</ng-container>
			</section>
		</section>
	</section>

	<section *ngIf="hasSecondaryMenu && singleColumnSecondaryMenu && dropdownMenu.id!=='user'" class="single-column-section">
		<ng-container *ngFor="let secondarySubitem of singleColumnSecondaryMenuItems; let ii=index; trackBy:identify">
			<button mat-menu-item
				*ngIf="secondarySubitem && !secondarySubitem.outletLink && secondarySubitem.hide===false && !secondarySubitem.externallink && !secondarySubitem.singleLayerRouting"
				id="menu-main-nav-lnk-dropdown-menu-{{parentId}}-{{secondarySubitem.id}}-{{ii}}"
				class="mt-0 py-2 border-radius-0 outline-none h-auto dropdown-menu-item"
				attr.aria-label="{{secondarySubitem.label| translate}}"
				routerLinkActive="active"
				[routerLinkActiveOptions]="secondarySubitem.routerLinkActiveOptions"
				[routerLink]="secondarySubitem.path"
				(click)="OnClick(secondarySubitem)" href="javascript:void(0)" role="menuitem"
				(keydown.enter)="OnClick(secondarySubitem)">
				<span class="d-inline-block overflow-hidden w-auto" [innerHTML]="secondarySubitem.label | translate"></span>
			</button>
			<button mat-menu-item
				*ngIf="secondarySubitem && secondarySubitem.outletLink && secondarySubitem.hide===false && !secondarySubitem.externallink && !secondarySubitem.singleLayerRouting"
				id="menu-main-nav-lnk-dropdown-menu-{{parentId}}-{{secondarySubitem.id}}-{{ii}}"
				class="mt-0 py-2 border-radius-0 outline-none h-auto dropdown-menu-item"
				attr.aria-label="{{secondarySubitem.label| translate}}" routerLinkActive="active"
				[routerLinkActiveOptions]="secondarySubitem.routerLinkActiveOptions"
				[routerLink]="secondarySubitem.outletLink" href="javascript:void(0)" role="menuitem"
				(keydown.enter)="OnClick(secondarySubitem)">
				<span class="d-inline-block overflow-hidden w-auto" [innerHTML]="secondarySubitem.label | translate"></span>
			</button>
			<button mat-menu-item
				*ngIf="secondarySubitem && secondarySubitem.hide===false && !secondarySubitem.externallink && secondarySubitem.singleLayerRouting"
				id="menu-main-nav-lnk-dropdown-menu-{{parentId}}-{{secondarySubitem.id}}-{{ii}}"
				class="mt-0 py-2 border-radius-0 outline-none h-auto dropdown-menu-item"
				attr.aria-label="{{secondarySubitem.label| translate}}" routerLinkActive="active"
				[routerLinkActiveOptions]="secondarySubitem.routerLinkActiveOptions" routerLink="/{{secondarySubitem.path}}"
				href="javascript:void(0)" role="menuitem" (keydown.enter)="menuItemKeyDown(secondarySubitem.path)">
				<span class="d-inline-block overflow-hidden w-auto" [innerHTML]="secondarySubitem.label | translate"></span>
			</button>
		</ng-container>
	</section>
</mat-menu>
